import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
// Side-effect import: installs cookie-credentials interceptor on window.fetch.
// MUST run before any component issues a fetch.
import "./services/authFetchSetup";
import { registerServiceWorker } from "./services/registerServiceWorker";
import { installClientErrorReporting } from "./services/clientErrorReporter";
import { installConsoleGuard } from "./services/consoleGuard";
import App from "./App";

installConsoleGuard();
installClientErrorReporting();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// Register the PWA service worker AFTER initial render so it never blocks paint.
registerServiceWorker();
